import { render, staticRenderFns } from "./CargoExpensePermitionsDropdown.vue?vue&type=template&id=2bb79ccd"
import script from "./CargoExpensePermitionsDropdown.vue?vue&type=script&lang=js"
export * from "./CargoExpensePermitionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports